<div class="node-wrapper">
  <ng-container *ngFor="let node of nodes; let i = index">
    <ion-accordion-group
      *ngIf="
        node.nodeType === NodeType.GROUP || node.nodeType === NodeType.DATE || node.nodeType === NodeType.VEHICLE
      "
    >
      <ion-accordion value="panel">
        <ion-item class="item" slot="header" lines="none">
          <ion-label class="files-panel-title">{{ node.name }}</ion-label>
        </ion-item>

        <div *ngIf="node.items" slot="content">
            <app-file-list
              [nodes]="node.items"
              [prefix]="prefix + 'child-' + i + '-'"
              [currentShipmentDate]="getShipmentDateForNode(node)"
            ></app-file-list>
        </div>
      </ion-accordion>
    </ion-accordion-group>

    <ng-container *ngIf="node.nodeType === NodeType.DOCUMENT" lines="none">
      <div class="file-wrapper">
        <div class="file-block">
          <app-file
            *ngIf="!node.items?.length"
            class="file"
            [file]="node"
            [fileIndex]="i"
            [parentDateName]="currentShipmentDate"
          ></app-file>

          <div *ngIf="node.isVerified || node.hasBES" class="signed-badge">
            Подписан
          </div>
        </div>

        <ion-button
          class="popover-toggle"
          fill="clear"
          [id]="prefix + 'click-trigger-' + i"
        >
          <img src="assets/icon/ellipse-btn.svg" alt="" />
        </ion-button>

          <ion-popover [trigger]="prefix + 'click-trigger-' + i">
          <ng-template>
            <ion-list>
                <ion-item button (click)="openDocument(node)">
                <ion-icon slot="start" name="document-text-outline"></ion-icon>
                <ion-label>Открыть</ion-label>
              </ion-item>
                <ion-item button (click)="shareDocument(node)">
                <ion-icon slot="start" name="share-outline"></ion-icon>
                <ion-label>Поделиться</ion-label>
              </ion-item>
            </ion-list>
          </ng-template>
        </ion-popover>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #missedFilesTpl>
    <div class="missed-files-block">Документы отсутствуют</div>
  </ng-template>
</div>
